import { Map } from 'immutable';
import {
  ISearchParams as IEntitySearchParams,
  NEW_ENTITY_ROUTE,
} from '../entity-data/entity-data.data';
import { Tax } from '../settings-data/sub-models/company-settings/tax.model';
import { Document } from './document.model';
import { Settings } from '../settings-data/settings.model';
import { IMessageDeliveryData } from '../message-delivery/message-delivery.interface';

export const DOC_FILTER_ACCEPT_VERSION = '2.2.0';
export const DOC_SEARCH_ACCEPT_VERSION = '5.3.0';
export const DOC_ACCEPT_VERSION = '7.1.0';
export const DOCUMENTS_SEARCH_ROUTE = 'search';
export const DOCUMENTS_CREATE_ROUTE = 'create';
export const DOCUMENTS_PREVIEW_ROUTE = 'preview';
export const DOCUMENTS_SEND_ROUTE = 'send';
export const DOCUMENTS_NEW_ROUTE = NEW_ENTITY_ROUTE;
export const ADD_APPOINTMENT_QUERY_PARAM = 'appointment_id';
export const ADD_CLIENT_QUERY_PARAM = 'client_id';
export const ADD_JOB_QUERY_PARAM = 'job_id';
export const FILTER_CLIENT_DOCUMENTS_QUERY_PARAM = 'filter';
export const ADD_TRACKED_TIME_QUERY_PARAM = 'tracked_time_id';
export const ADD_CLIENT_ACTION = 'add_client';
export const UPDATE_DEPOSIT_REQUEST_ACTION = 'update_deposit_request';
export const MANUAL_PAYMENT_ACTION = 'manual_payment';
export const CHARGE_A_CARD_ACTION = 'charge_a_card';
export const MAX_TERMS = 999;
export const MAX_LENGTH_DOCUMENT_ITEM_NAME = 255;
export const MAX_LENGTH_DOCUMENT_ITEM_DESCRIPTION = 3000;
export const MAX_DOCUMENT_ITEM_QUANTITY = 99999999999;
export const CONVERT_TO_INVOICE_DONT_ASK_ME_AGAIN_KEY =
  'convert_to_invoice_dialog_dont_ask_me_again';
export const ALL_YEARS = -1;
export const MAX_EMAIL_SIZE = 20_000_000; // total size should be < 20 MBs per email
export const ONE_KB_SIZE = 1000;
export const ONE_MB_SIZE = 1_000_000;
export const ONE_GB_SIZE = 1_000_000_000;

export enum DepositTransactionImpactTypesEnum {
  manual_payment_cancel = 'manual_payment_cancel',
  electronic_deposit = 'electronic_deposit',
  electronic_full_payment = 'electronic_full_payment',
}

export enum DepositPaymentStatesEnum {
  unpaid = 'unpaid',
  paid = 'paid',
  canceled = 'canceled',
}

export enum DepositRequestTrackingStatusesEnum {
  no_request = 'no_request',
  unpaid = 'unpaid',
  partially_paid = 'partially_paid',
}

export enum DepositTypesEnum {
  percentage = 'percentage',
  fixed_amount = 'fixed_amount',
  fixed_amount_percentage_screen = 'fixed_amount_percentage_screen',
}

export enum DocumentActionsEnum {
  approve_document = 'approve_document',
  copy_document = 'copy_document',
  convert_document_to_invoice = 'convert_document_to_invoice',
  decline_document = 'decline_document',
  delete_document = 'delete_document',
  email_document = 'email_document',
  mark_document_as_paid = 'mark_document_as_paid',
  print_document = 'print_document',
  record_document_transaction = 'record_document_transaction',
  save_document = 'save_document',
  export_document_to_xero = 'export_document_to_xero',
}

export enum DocumentFiltersEnum {
  all = 'all',
  paid = 'paid',
  unpaid = 'unpaid',
  pending = 'pending',
  done = 'done',
}

export enum DocumentOverallStatesEnum {
  fully_paid = 'fully_paid',
  opened = 'opened',
  overdue = 'overdue',
  partially_paid = 'partially_paid',
  sent = 'sent',
  unsent = 'unsent',
}

export enum DocumentEmailStatesEnum {
  unsent = 'unsent',
  sent = 'sent',
  opened = 'opened',
}

export enum DocumentScheduleIntervalEnum {
  weekly = 'weekly',
  fortnightly = 'fortnightly',
  monthly = 'monthly',
}

export enum DocumentTabsEnum {
  create = 'create',
  preview = 'preview',
  send = 'send',
}

export enum DocumentReferenceTypesEnum {
  client = 'client',
  product = 'product',
  expense = 'expense',
  tracked_time = 'tracked_time',
  appointment = 'appointment',
}

export enum DocumentTypesEnum {
  invoice = 'invoice',
  credit_memo = 'credit_memo',
  estimate = 'estimate',
  purchase_order = 'purchase_order',
}

export enum DocumentErrorsEnum {
  document_not_found = 'document not found',
  print_document_error = 'print document error',
  print_popup_blocked = 'popup blocked by browser',
}

export interface IEditTaxRateProperties {
  tax: Tax;
  documentProperties: Map<string, any>;
}

export interface ISearchParams extends IEntitySearchParams {
  document_tax_year?: number;
}

export interface ICopyDocumentOptions {
  sourceDocument: Document;
  copyAs: DocumentTypesEnum;
  copyClient: boolean;
  copyItems: boolean;
  copyAttachments: boolean;
  copyTaxes: boolean;
  saveCopy?: boolean;
  saveEditing?: boolean;
}

export interface ISendDocumentPayload {
  document: Document;
  settings: Settings;
  accountEmail: string;
  bankTransferFeatureEnabled: boolean;
  cardPaymentsFeatureEnabled: boolean;
  paypalFeatureEnabled: boolean;
  messageDeliveryData: IMessageDeliveryData;
  hasTrackingFeature: boolean;
  emailTemplateExperiment: boolean;
}
